import { gql } from "@apollo/client";

export const listOperatorUsers = gql`
  mutation listOperatorUsers($params: ListOperatorPermissionsInput!) {
    listOperatorUsers(params: $params) {
      status
      missingRoles
    }
  }
`;